import { z } from 'zod'

export const paramsSchema = z.object({
  slug: z.string(),
})

export type paramsType = z.infer<typeof paramsSchema>
